import Vue from 'vue'
import {
    Button, Container, Header, Aside, Main, Footer, Row, Col, Image, Menu, Submenu, MenuItem, MenuItemGroup, Carousel,
    CarouselItem, Divider,MessageBox,Message,Breadcrumb,BreadcrumbItem, Pagination
} from 'element-ui';

import App from './App'
import router from "./router";//导入的是目录自动会寻找里面的index文件（导入路由）
Vue.use(Button);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Row);
Vue.use(Col);
Vue.use(Image);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Divider);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem)
Vue.use(Pagination)
Vue.config.productionTip = false
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$message = Message;
new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
